/** Champ vidé : la valeur stockée est retirée. */
export const isEmptyTyped = (typed) => typed === '' || typed == null;

/* Mantine renvoie la saisie en cours telle quelle (« - », « 1e ») : pas encore
   un nombre, elle s'écrirait en NaN, sérialisé en null. */
export const isIncompleteNumber = (typed) => !isEmptyTyped(typed) && !Number.isFinite(Number(typed));
